module.exports = __webpack_public_path__ + "img/logo-06.5b355119.png";